import { render } from "./QuickNav.vue?vue&type=template&id=2c256982"
import script from "./QuickNav.vue?vue&type=script&lang=js"
export * from "./QuickNav.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__